module.exports = __webpack_public_path__ + "media/images/logo1_nodc-2f95d6fa953382f7116af6eeb556905e.png";